import React from 'react';
import classnames from 'classnames';

// Styles
import './QsgTitle.scss';

type Props = {
  prefixButton?: React.ReactNode;
  postfixButton?: React.ReactNode;
  title: string;
  inverseGradient?: boolean;
};

const QsgTitle = ({ title, prefixButton, postfixButton, inverseGradient = false }: Props) => {
  const baseClassName = 'QsgTitle';
  const classes = classnames(baseClassName, inverseGradient && `${baseClassName}--inverse-gradient`);

  return (
    <div className={classes}>
      {prefixButton && <div className={`${baseClassName}__button ${baseClassName}__prefix-button`}>{prefixButton}</div>}
      <div className={`${baseClassName}__title`}>{title}</div>
      {postfixButton && (
        <div className={`${baseClassName}__button ${baseClassName}__postfix-button`}>{postfixButton}</div>
      )}
    </div>
  );
};

export default QsgTitle;
